import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as AnnotationsActions from './annotations.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class AnnotationsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new AnnotationsActions.AnnotationsRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.ANNOTATIONS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new AnnotationsActions.AnnotationsCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new AnnotationsActions.AnnotationsUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new AnnotationsActions.AnnotationsDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new AnnotationsActions.AnnotationsRefresh());
          break;
      }
    });
  }
}
